/* Whole days, hours, minutes and seconds left in a span of seconds — what every
 * countdown on the site prints.
 *
 * The timers used date-fns' `intervalToDuration` counted from the epoch, which
 * rolls days past a month boundary into a `months` field none of them prints:
 * a draw 34 days out read "03 Days" on the giveaway page, the portal and the
 * dashboard the day the monthly A$10,000 draw started opening more than four
 * weeks ahead (2026-10-24). Plain division cannot roll over. */
export type CountdownParts = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

export const countdownParts = (totalSeconds: number): CountdownParts => {
  const s = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  return {
    days: Math.floor(s / 86400),
    hours: Math.floor((s % 86400) / 3600),
    minutes: Math.floor((s % 3600) / 60),
    seconds: s % 60
  };
};
